import { useCallback, useContext, useEffect } from "react";
import { BiUser } from "react-icons/bi";
import { TbDoorExit } from "react-icons/tb";
import { useNavigate } from "react-router";
import { PurpleButton } from "../../components/buttons/purpleButton";
import { AuthContext } from "../../context/AuthContext";
import usuarioService from "../../services/usuarioService";
import { scrollUp } from "../../utils/pageUtils";
import { Container, ExitButton, MenuAdmin, MenuButton } from "./styles";

export const Admin = () => {
  const { signOut, user, token } = useContext(AuthContext);
  const navigate = useNavigate();

  const verifyToken = useCallback(async () => {
    try {
      const response = await usuarioService.verifyAuth();
      if (response.data !== "autenticado") {
        signOut();
      }
    } catch {
      signOut();
    }
  }, [signOut]);

  useEffect(() => {
    scrollUp();
    if (!token) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      void verifyToken();
    }, 100);

    return () => window.clearTimeout(timeoutId);
  }, [token, verifyToken]);

  return (
    <Container>
      <MenuAdmin>
        <div>
          <BiUser
            style={{
              borderRadius: "50%",
              background: "#222226",
              padding: "0.5rem",
            }}
            size={54}
          />
          <section>
            <p>Bem Vindo!</p>
            <h1>{user?.nome}</h1>
          </section>
        </div>
        <ExitButton onClick={signOut}>
          Sair
          <TbDoorExit size={28} />
        </ExitButton>
      </MenuAdmin>
      <MenuButton>
        <PurpleButton
          style={{ width: "100%" }}
          title="Adicionar Conveniado Saude"
          onClick={() => navigate("/conveniado-saude/adicionar")}
        />
        <PurpleButton
          style={{ width: "100%" }}
          title="Gestão de conveniados Saude"
          onClick={() => navigate("/conveniado/gestao-saude")}
        />
        <PurpleButton
          style={{ width: "100%" }}
          title="Adicionar Desconto"
          onClick={() => navigate("/descontos/adicionar")}
        />
        <PurpleButton
          style={{ width: "100%" }}
          title="Gestão de Descontos"
          onClick={() => navigate("/descontos/gestao")}
        />
        <PurpleButton
          style={{ width: "100%" }}
          title="Gestão do Carrossel"
          onClick={() => navigate("/carrossel/gestao")}
        />

        <PurpleButton
          style={{ width: "100%" }}
          title="Atualizar Ads"
          onClick={() => navigate("/ads/post")}
        />
      </MenuButton>
    </Container>
  );
};
